import Head from "next/head"
import React from "react"

import Footer from "~/components/organisms/Footer"
import { NewGradScout } from "~/components/pages/NewGradScoutPage"

const NewGradScoutPage = ({}) => {
  return (
    <>
      <Head>
        <title>Infra 新卒 | あなたの Only One な経験に、One to One のスカウトを</title>
        <meta
          name="description"
          content="「Infra 新卒」は、あなたのプロフィールを評価した企業から One to One のオファーが届くスカウトサービスです。"
        />
        <meta name="og:title" content="Infra 新卒 | あなたの Only One な経験に、One to One のスカウトを" />
        <meta
          name="og:description"
          content="「Infra 新卒」は、あなたのプロフィールを評価した企業から One to One のオファーが届くスカウトサービスです。"
        />
        <meta name="og:image" content="/next/static/images/new-grad-scout/ogp.png" />
      </Head>
      <NewGradScout />
      <Footer />
    </>
  )
}

export default NewGradScoutPage
